import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Heart } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

// Bouton « Je recommande » : compteur local distinct des notes 1-5 étoiles.
export default function RecommendButton({ businessId, className = "" }) {
  const { user } = useAuth();
  const nav = useNavigate();
  const location = useLocation();
  const [count, setCount] = useState(0);
  const [mine, setMine] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!businessId) return;
    api.get(`/businesses/${businessId}/recommendations`)
      .then((r) => { setCount(r.data?.count || 0); setMine(!!r.data?.recommended); })
      .catch(() => {});
  }, [businessId]);

  const toggle = async () => {
    if (!user) {
      toast.message("Connectez-vous pour recommander ce commerce.");
      nav(`/connexion?redirect=${encodeURIComponent(location.pathname + location.search)}`);
      return;
    }
    setBusy(true);
    try {
      const { data } = await api.post(`/businesses/${businessId}/recommend`);
      setCount(data.count);
      setMine(data.recommended);
      toast.success(data.recommended
        ? "Merci, vous recommandez ce commerce 🧡"
        : "Recommandation retirée.");
    } catch {
      toast.error("Une erreur est survenue.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Button
      type="button"
      onClick={toggle}
      disabled={busy}
      data-testid="biz-recommend-btn"
      className={`h-10 shrink-0 justify-center font-semibold transition-colors active:scale-[0.98] ${
        mine
          ? "bg-[#E05638] hover:bg-[#c7482d] text-white border border-[#E05638]"
          : "bg-white text-[#E05638] border border-[#E05638]/40 hover:bg-orange-50"
      } ${className}`}
    >
      <Heart size={15} className={`mr-1.5 ${mine ? "fill-white" : ""}`} />
      Je recommande
      <span
        data-testid="biz-recommend-count"
        className={`ml-2 inline-flex items-center justify-center min-w-[20px] h-5 px-1 rounded-full text-xs font-bold ${
          count > 0 ? (mine ? "bg-white/25 text-white" : "bg-orange-100 text-[#E05638]") : "opacity-0"
        }`}
      >
        {count > 0 ? count : 0}
      </span>
    </Button>
  );
}
